export { SocialMediaIcon } from './SocialMediaIcon';
